import React from "react";
import Icon from "images/icons/white/user.svg";
import { Wrapper, Image } from "./styled";

const UserIcon = ({ onClick }) => {
  return (
    <Wrapper onClick={onClick}>
      <Image src={Icon} alt="icon" />
    </Wrapper>
  );
};

export default UserIcon;
